import {
  CreateCalendarSyncDocument,
  CreateCalendarSyncMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateCalendarSync = () => {
  const [createAccessCalendarSync, { loading }] = useMutation(CreateCalendarSyncDocument, {
    extractorFn: (data) => data.cronofySchedulingMutations.createCronofyschedulingCalendarSync,
  })

  return {
    loading,
    createCalendarSync(variables: CreateCalendarSyncMutationVariables) {
      return createAccessCalendarSync({
        variables,
      })
    },
  }
}
